import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { CompanySettings } from "@/data/models/Settings";
import { createDefaultCompanySettings } from "@/data/models/Client";

const name = "companySettings";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class CompanySettingsVuexModule extends VuexModule {
  companySettings: CompanySettings = createDefaultCompanySettings();

  @Mutation
  setCompanySettings(companySettings: CompanySettings) {
    this.companySettings = companySettings;
  }

  @Mutation
  clear() {
    this.companySettings = createDefaultCompanySettings();
  }
}

export const CompanySettingsModule = getModule(CompanySettingsVuexModule, store);
